import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Radio, Input, Select } from "antd";
import fetchHandler from "@/fetch/fetchHandler";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { updateCostCfg, insertCostCfg } from "../../../fetch/fetchApi";

const FormItem = Form.Item;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class CfgLoogUpInsertClass extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sortTypeOption:JSON.parse(window.sessionStorage.getItem('sortTypeOption')),
      internationalization: this.props.intl.messages.CfgLoogUpInsert,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        //巡检费用数值判断，设备型号长度判断
        if (values.deviceModel.length > 50)
        {
          message.error('设备型号最大长度不能超过50个字符');
          return;
        }
        const number = /^(\-|\+)?\d+(\.\d+)?$/;
        if (values.price && !number.test(values.price))
        {
          message.error('巡检费用必须填写数值类型');
          return;
        }
        this.setState({
          btnLoading: true,
        });
        if (!this.props.stubId || this.props.stubId == null)
        {
          values.ticketType = 3;
          values.costName = '巡检费用';
          values.settleWay = 1;
          values.isEnable = 1;
          values.num = 1;
        } else {
          values.id = this.props.stubId.key;
        }
        fetchHandler(values.costName && values.costName != null ? insertCostCfg : updateCostCfg, {
          ...values,
        }).then((res) => {
          if (this.props.setSelectedRowKeysNull) {
            this.props.setSelectedRowKeysNull();
          }
          if (res && res.code === "success") {
            message.success(this.state.internationalization.msg1); // '操作成功');
            if (this.props.onCancel) {
              this.props.onCancel();
            }
            if (this.props.refreshGrid) {
              this.props.refreshGrid();
            }
          }
          this.setState({
            btnLoading: false,
          });
        });
      }
    });
  };


  
  // 验证数值大小
  checkNumVal(rule, value, callback, item) {
    // eslint-disable-next-line no-useless-escape
    const number = /^(\-|\+)?\d+(\.\d+)?$/;
    if (
      (value && item.max_val && +value > +item.max_val) ||
      (value && item.min_val && +value < +item.min_val)
    ) {
      callback(
        `${this.internationalization.msg5}${item.min_val}${
          item.max_val
            ? this.internationalization.msg5_2 + this.internationalization.msg5_3 + item.max_val
            : ""
        }`,
      );
    } else if (
      value &&
      item.max_point &&
      value.split(".") &&
      value.split(".")[1] &&
      value.split(".")[1].length > +item.max_point
    ) {
      callback(`${this.internationalization.msg6}${item.max_point}`);
    } else if (value && !number.test(value)) {
      callback(this.internationalization.msg7);
    } else {
      callback();
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 5 },
      },
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 30 },
        sm: { span: 15, offset: 1 },
      },
    };
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
        <FormItem {...formItemLayout} label={this.state.internationalization.title2}>
              {getFieldDecorator("deviceModel", {
                rules: [
                  {
                    required: true,
                    message: "请输入设备型号",
                  },
                ],
                initialValue: this.props.stubId == null ? null : this.props.stubId.deviceModel,
              })(
              <Select
              showSearch
                  onSelect={(value, option) => {
                    // this.changeTableSort("table1Value", option);
                  }}>
                  {this.state.sortTypeOption.deviceModel.map(element => {
                     return (
                      <Option key={element} value={element}>
                        {element}
                      </Option>
                    );
                  })}
                </Select>,
              )}
          </FormItem>

          <FormItem  {...formItemLayout} label='巡检类型'>
            {getFieldDecorator("isXun", {
              rules: [
                {
                  required: true,
                  message: '请选择巡检类型', // "请选择要设备类型"
                },
              ],
              initialValue: this.props.stubId == null ? '1' : this.props.stubId.isXun + '',
            })(
              <Radio.Group>
                <Radio key="1" value="1">清洁工单</Radio>
                <Radio key="2" value="2">巡检工单</Radio>
                <Radio key="6" value="6">保养工单</Radio>
              </Radio.Group>,
              )}
          </FormItem>
          <FormItem  {...formItemLayout} label={this.state.internationalization.title1}>
            {getFieldDecorator("deviceType", {
              rules: [
                {
                  required: true,
                  message: this.state.internationalization.placeholder1, // "请选择要设备类型"
                },
              ],
              initialValue: this.props.stubId == null ? '0' : this.props.stubId.deviceType + '',
            })(
              <Radio.Group>
                <Radio key="0" value="0">交流电</Radio>
                <Radio key="1" value="1">直流电</Radio>
                <Radio key="2" value="2">交直流电</Radio>
              </Radio.Group>,
              )}
          </FormItem>
          <FormItem {...formItemLayout} label={this.state.internationalization.title3}>
              {getFieldDecorator("price", {
                rules: [
                  {
                    required: true,
                    message: "请输入巡检费用",
                  },
                ],
                initialValue: this.props.stubId == null ? null : this.props.stubId.price,
              })(<Input />)}
          </FormItem>
          <FormItem {...tailFormItemLayout} style={{ marginTop: 14 }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}>
              {this.state.internationalization.btn1}
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

const CfgLoogUpInsert = Form.create()(CfgLoogUpInsertClass);

export default injectIntl(CfgLoogUpInsert);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/cfgLoogUpInsert.js